import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(weekday);
import SUPPORTED_LOCALES from 'dayjs/locale.json';

const findLocale = (languageCode) => SUPPORTED_LOCALES.find((locale) => locale.key === languageCode.toLowerCase());

function findBestLocale(originalLanguageCode) {
  const foundLocales = findLocale(originalLanguageCode);
  if (foundLocales?.key) return foundLocales.key;

  // try the language code without locale
  const shortLocale = originalLanguageCode.split('-')[0];
  const languageLocale = findLocale(shortLocale);
  if (languageLocale?.key) return languageLocale.key;
}

export default async function loadDayjsLocale(language, defaultLocale) {
  const bestLocale = findBestLocale(language) || defaultLocale;
  try {
    await import(`dayjs/locale/${bestLocale}.js`);

    dayjs.locale(bestLocale);
  } catch (error) {
    console.error(`Failed to load dayjs locale ${bestLocale}: ${error.message}`);
  }
}
